import { productosBalanzas } from './balanzas.js';
import { productosPlataformas } from './plataformas.js';
import { productosBasculasCamiones } from './basculas_camiones.js';
import { productosPesajeDinamico } from './pesaje_dinamico.js';
import { productosEtiquetado } from './etiquetado.js';
import { productosIndicadores } from './indicadores.js';
import { basculasColgar } from './basculas_colgar.js';
import { masasPatrones } from './masas_patrones.js';
import celdasCargas from './celdas_cargas.js';
import balanzasPedestalPacking from './balanzas_pedestal_packing.js';

// Combinar todos los productos
export const todosLosProductos = [
  ...productosBalanzas,
  ...productosPlataformas,
  ...productosBasculasCamiones,
  ...productosPesajeDinamico,
  ...productosEtiquetado,
  ...productosIndicadores,
  ...basculasColgar,
  ...masasPatrones,
  ...celdasCargas,
  ...balanzasPedestalPacking
];

// Exportar por categorías
export {
  productosBalanzas,
  productosPlataformas,
  productosBasculasCamiones,
  productosPesajeDinamico,
  productosEtiquetado,
  productosIndicadores,
  basculasColgar,
  masasPatrones,
  celdasCargas,
  balanzasPedestalPacking
}; 